let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("4d8vq")).then(() => parcelRequire('7jsM3'));